module.exports = __webpack_public_path__ + "img/6s.e8490edc.png";